<template>
    <div class="header">
        <div class="header-pc clearfix container">
            <div class="logo">
                <img src="../../../assets/img/mainPage/logo.png" alt="logo" class="cursor-pointer"
                    @click="jumpPage('/home')" />
            </div>
            <div class="tel">
                <img src="../../../assets/img/mainPage/tel.png" alt="tel"></img>
                <p>029-68255490</p>
            </div>
            <el-menu :default-active="activeIndex.toString()" class="nav clearfix" mode="horizontal">
                <el-menu-item :index="index.toString()" @click="jumpPage(item.url)" class="cursor-pointer"
                    v-for="(item,index) in topMenuList" :key="index">
                    {{item.name}}
                </el-menu-item>
            </el-menu>
        </div>
        <div class="app-head clearfix container">
            <div class="logo">
                <img src="../../../assets/img/mainPage/logo.png" alt="logo" class="cursor-pointer"
                    @click="jumpPage('/home')" />
            </div>
            <i class="el-icon-menu" @click="toggleMenu"></i>
            <el-menu :default-active="activeIndex.toString()" v-show="showMenu" class="header-menu"
                :unique-opened="true">
                <el-menu-item :index="index.toString()" @click="jumpPage(item.url)" class="cursor-pointer"
                    v-for="(item,index) in topMenuList" :key="index">
                    {{item.name}}
                </el-menu-item>
            </el-menu>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showMenu: false,
            activeIndex:'0',
            topMenuList:[{name:'首页',url:'/home'},{name:'产品中心',url:'/product'},{name:'项目案例',url:'/case'},{name:'资质证书',url:'/certificate'},{name:'关于我们',url:'/aboutus'}]
        }
    },
    methods: {
        jumpPage(url) {
            this.showMenu = false
            this.$router.push(url)
        },
        toggleMenu() {
            this.showMenu = !this.showMenu
        },
    },
    mounted(){
        let path=this.$route.path
        if (path) {
            this.topMenuList.map((item,index)=>{
                if(path.includes(item.url))
                {
                    this.activeIndex = index
                    return;
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.header{
    width:100%;
    background: #FFFFFF;
}
.header-pc {
    margin: 0px auto;
    height: 84px;

    .logo {
        float: left;
        margin-top: 14px;
        margin-left: -50px;

        img {
            vertical-align: middle;
        }
    }

    .nav {
        float: right;

        li {
            padding-top: 15px;
            margin-left: 11px;
            height: 84px;
            font-size: 16px;
            color:#575757;
            font-family: 'MicrosoftYaHei';
        }
    }

    .tel{
        float:right;
        margin-left:60px;
        line-height: 84px;
        img{
            height:16px;
            display: inline-block;
            vertical-align: middle;
        }
        p{
            color:#0C1324;
            font-size: 16px;
            font-weight: bold;
            display: inline-block;
            vertical-align: middle;
            margin-left: 10px;
        }
    }
}

/deep/ .el-menu.el-menu--horizontal{
    border-bottom:none;
}
/deep/.el-menu--horizontal>.el-menu-item.is-active{
    border-bottom: 4px solid #06B70E;
    color:#06B70E;
}
</style>
